// eslint-disable-next-line no-unused-vars
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';
import { breakpoints, colors, unitConverter as uc } from '../../../styles/base';
import ProductCategorySection from '../Menu/MenuSection/ProductCategorySection/ProductCategorySection';
import { Heading4 } from '../../atoms/Headings/Headings';

const ClientSideBar = ({
  clientProducts,
  heading,
  heading4Css,
  productCategoryEntity,
}) => {
  // override white background from suitesection
  const productCategoryCss = css`
    margin-bottom: ${uc('25px')};

    div {
      background: ${colors.lightGray.six};

      h2,
      p {
        width: 100%;
      }
    }

    div:nth-of-type(2) {
      width: 85%;
    }

    @media (${breakpoints.largeTablet}) {
      > div {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
      }

      div h2,
      div p {
        display: inline-block;
        white-space: normal !important;
        word-wrap: break-word;
      }

      .icon-link-subheading {
        flex-wrap: wrap;
        width: 50%;
        padding: 0;
        text-align: center;

        &:first-of-type {
          padding-top: 0 !important;
        }

        &:last-of-type {
          padding-bottom: 0 !important;
        }

        div {
          width: auto;
          height: auto;
        }
      }
    }

    @media (${breakpoints.tablet}) {
      .icon-link-subheading {
        width: 50%;
      }
    }

    @media (${breakpoints.mobile}) {
      width: 95%;
      padding-left: 0;

      .icon-link-subheading {
        flex-wrap: nowrap;
        justify-content: space-between;
        width: 100%;
        padding: ${uc('20px 0 0 0')};
        text-align: left;

        div {
          width: auto;

          h2 {
            width: auto;
          }
        }
      }
    }
  `;
  const clientProductCategory = clientProducts.map(productCategory =>
    productCategory.displayName.toLowerCase()
  );

  // generate usedProducts and otherProducts Array
  const usedProducts = [];
  const otherProducts = productCategoryEntity.reduce((acc, productCategory) => {
    if (
      clientProductCategory.includes(
        productCategory.node.displayName.toLowerCase()
      )
    ) {
      usedProducts[productCategory.node.productOrdering] = productCategory.node;
      return acc;
    }
    acc[productCategory.node.productOrdering] = productCategory.node;
    return acc;
  }, []);
  return (
    <div className="productCategory-used" css={productCategoryCss}>
      {usedProducts.length > 0 ? (
        <ProductCategorySection productCategorySectionItems={usedProducts} />
      ) : null}
      {otherProducts.length > 0 ? (
        <Heading4 css={heading4Css}>{heading}</Heading4>
      ) : null}
      {otherProducts.length > 0 ? (
        <ProductCategorySection productCategorySectionItems={otherProducts} />
      ) : null}
    </div>
  );
};

/**
 * Prop types
 */
ClientSideBar.propTypes = {
  clientProducts: PropTypes.arrayOf(PropTypes.shape({})),
  heading4Css: PropTypes.shape({}),
  heading: PropTypes.string,
  productCategoryEntity: PropTypes.arrayOf(PropTypes.shape({})),
};

/**
 * Default props
 */
ClientSideBar.defaultProps = {
  clientProducts: [],
  heading4Css: {},
  heading: '',
  productCategoryEntity: [],
};

export default ClientSideBar;
